import React from 'react';
import { View } from 'react-native';
import EmptyListPlaceholder from '@/components/General/EmptyListPlaceholder';
import Callout from '@/components/General/Callout';

/**
 * Setup-needed state: the org flag is on but no SmallGroupType with
 * purpose='BIBLE_STUDY' and a teacher roleID exists. Types are managed in the
 * existing Small Group Types admin screens — this is a hint, not a
 * free-for-all type picker.
 */
const BibleStudySetupNeeded = ({ canManage = false }) => {
    return (
        <View style={{ flex: 1, padding: 20 }}>
            <EmptyListPlaceholder
                icon="book-outline"
                spacing={20}
                message="Bible Studies isn't set up for this organization yet."
            />
            {canManage && (
                <Callout
                    type="info"
                    title="Setup required"
                    message="Create a Small Group Type set aside for Bible Studies with a teacher role assigned (Small Groups → Types). Teachers must be rostered in that role before they can lead studies."
                />
            )}
        </View>
    );
};

export default BibleStudySetupNeeded;
